
















































































































































import { Component, Vue } from "vue-property-decorator";
import { AppUserDayViewModel, NewsModel, RightEnum, TimeEntryDay } from "@/services/api/nswag/stapiclient_generated";
import DateSlider from "@/views/TimeEntries/Components/DateSlider.vue";
import { DateTime } from "luxon";
import { dateEqual, DateForEach, endOfWeek, startOfWeek } from "@/utlitities/helper";
import TimeEntryEdit from "@/views/TimeEntries/TimeEntryEdit/TimeEntryEdit.vue";
import PauseEdit from "@/views/TimeEntries/TimeEntryEdit/PauseEdit.vue";
import { UserStore } from "@/store/user-module";
import { TimeEntryStore } from "@/store/time-entry-store";

import TimeEntry from "@/views/TimeEntries/TimeEntry.vue";
import PauseEntry from "@/views/TimeEntries/PauseEntry.vue";
import StopwatchOldLayout from "@/views/Stopwatch/OldLayout/StopwatchOldLayout.vue";
import { stNewsApi, stTimeEntryApi } from "@/services/st-api";
import { notifySuccess } from "@/utlitities/notifications";
import StBadge from "@/components/basic/StBadge.vue";
import { StopwatchStore } from "@/store/stopwatch-store";
import UserSelect from "@/views/TimeEntries/UserSelect.vue";
import TimeEntriesApproval from '@/views/TimeEntries/Components/TimeEntriesApproval.vue';
import AutoPauseEntry from "@/views/TimeEntries/AutoPauseEntry.vue";
import TimeAccountSummary from '@/views/TimeEntries/Components/TimeAccountSummary.vue';

Component.registerHooks(["beforeRouteUpdate", "beforeRouteEnter"]);

@Component({
  components: {
    TimeAccountSummary,
    TimeEntriesApproval,
    PauseEntry,
    AutoPauseEntry,
    TimeEntry,
    DateSlider,
    TimeEntryEdit,
    PauseEdit,
    StopwatchOldLayout,
    StBadge,
    UserSelect
  }
})
export default class TimeEntries extends Vue {
  copyLastWorkdayLoading: boolean = false;
  copyWeekBeforeLoading: boolean = false;

  loading = false;
  delayLoading = false;

  newsModel: NewsModel = NewsModel.fromJS({});

  async mounted() {
    try {
      this.loading = true;
      if(!this.selectedUserId){
        this.selectedUserId = UserStore.currentUser.id ?? 0;
      }

      await this.loadData(this.selectedDate);
      await StopwatchStore.loadStopwatch();
    } finally {
      this.loading = false;
    }
    this.getNews();
  }

  async beforeRouteEnter(to: any, from: any, next: any) {
    TimeEntryStore.Reset(false);
    next();
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == "TimeEntries") {
      try {
        this.delayLoading = true;
        await this.loadData(this.selectedDate);
      } finally {
        this.delayLoading = false;
      }
    }
  }

  get useTimeApproval() {
    return UserStore.userSettings.needsTimeEntryApproval;
  }

  get useTimeAccountSummary() {
    return UserStore.userSettings.featureFlagTimeAccountSummaryOnTimeEntryPage && UserStore.currentUser.tempUseNewTimeAccountSummary;
  }

  get selectedUserId(){
    return TimeEntryStore.selectedUserId;
  }

  set selectedUserId(data: number){
    TimeEntryStore.SetSelectedUserId(data);
  }

  get useProjectTimeTracking() {
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  get canEditTimeEntriesEnumValue(): RightEnum {
    return RightEnum.CanEditTimeEntriesForEmployees;
  }

  get hasFeatureFlagTimeApproval(){
    return UserStore.userSettings.featureFlagTimeApproval;
  }

  async getNews() {
    this.newsModel = await stNewsApi.getNews();
  }

  async newsClicked() {
    await stNewsApi.newsClicked();
    this.getNews();
  }

  get isDifferentUser() {
    return this.selectedUserId != UserStore.currentUser.id;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get accountIsLocked() {
    return UserStore.userSettings.accountIsLocked;
  }

  get items() {
    if (!TimeEntryStore.TimeEntryDays?.length || this.dateNotInSlider(this.selectedDate)) {
      let startOfWeekDt = startOfWeek(this.selectedDate);
      let endOfWeekDt = endOfWeek(this.selectedDate);

      let dts = DateForEach(startOfWeekDt, endOfWeekDt);

      return dts.map((x) => {
        return TimeEntryDay.fromJS({
          entryDay: x.toISODate(),
          timeEntries: [],
          appUserDay: AppUserDayViewModel.fromJS({ dayDescription: {} }),
          revenue: 0,
          durationMinutes: 0
        });
      });
    }

    return TimeEntryStore.TimeEntryDays;
  }

  set items(data: TimeEntryDay[]) {
    TimeEntryStore.SetTimeEntryDays(data);
  }

  get userDatePattern() {
    return UserStore.userSettings.datePattern;
  }

  get selectedDate() {
    return TimeEntryStore.SelectedDate;
  }

  set selectedDate(data: DateTime) {
    TimeEntryStore.SetSelectedDate(data);
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  get useManualPause() {
    return UserStore.useManualPause;
  }

  get allowEntriesOnFreeDays() {
    return true;
  }

  get showFullWeek() {
    return UserStore.userSettings.timeEntriesShowFullWeek;
  }

  isSelectedDate(entryDay: string) {
    return dateEqual(this.selectedDate, DateTime.fromISO(entryDay));
  }

  displayDay(day: TimeEntryDay) {
    if (
      day.timeEntries!.length > 0 ||
      day.entryDay?.substring(0, 10) == this.selectedDate.toFormat("yyyy-MM-dd") ||
      this.openDays.indexOf(day.entryDay!.substring(0, 10)) !== -1
    ) {
      return true;
    }
  }

  private openDays: string[] = [];

  collapse(day: TimeEntryDay) {
    if (this.openDays.filter((_) => _ == day.entryDay!.substring(0, 10)).length) {
      this.openDays = this.openDays.filter((_) => _ != day.entryDay?.substring(0, 10));
    } else {
      this.openDays.push(day.entryDay!.substring(0, 10));
    }
  }

  dateNotInSlider(date: DateTime) {
    return (
      !TimeEntryStore.TimeEntryDays?.length ||
      !TimeEntryStore.TimeEntryDays.some((x) => {
        return dateEqual(DateTime.fromISO(x.entryDay!), date);
      })
    );
  }

  async changeSelectedDate(date: DateTime) {
    this.selectedDate = date;

    //scroll day into view if we display the whole week
    if (UserStore.currentUser.timeEntriesShowFullWeek) {
      const dayHeader = document.getElementById(this.selectedDate.toFormat("yyyy-MM-dd"));
      if (dayHeader) {
        dayHeader.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }
    }

    if (this.dateNotInSlider(date)) {
      try {
        this.loading = true;
        await this.loadData(date);
      } finally {
        this.loading = false;
      }
    }
  }

  async approvalChanged() {
    await this.loadData(this.selectedDate);
  }

  addTimeEntry(day: string) {
    let date = DateTime.fromISO(day);

    if (this.isDifferentUser) {
      this.$router.push({
        name: "TimeEntryAddForUser",
        params: {
          id: "0",
          appUserId: this.selectedUserId.toString(),
          entryDate: date.toFormat("yyyy-MM-dd")
        }
      });
    } else {
      this.$router.push({ name: "TimeEntryAdd", params: { id: "0", entryDate: date.toFormat("yyyy-MM-dd") } });
    }
  }

  addPauseEntry(day: string) {
    let date = DateTime.fromISO(day);
    this.$router.push({ name: "PauseAdd", params: { id: "0", entryDate: date.toFormat("yyyy-MM-dd") } });
  }

  async copyLastWorkday(day: TimeEntryDay) {
    try {
      this.copyLastWorkdayLoading = true;
      let copied = await stTimeEntryApi.copyLastWorkday(this.selectedUserId, day.entryDay!);
      await this.loadData(DateTime.fromISO(day.entryDay!));
      if (!copied) {
        notifySuccess("Es wurden keine Zeiteinträge zum kopieren gefunden.");
      } else {
        if (copied == 1) {
          notifySuccess(`Es wurde ${copied} Zeiteintrag kopiert`);
        } else {
          notifySuccess(`Es wurden ${copied} Zeiteinträge kopiert`);
        }
      }
    } finally {
      this.copyLastWorkdayLoading = false;
    }
  }

  async copyFromDayWeekBefore(day: TimeEntryDay) {
    try {
      this.copyWeekBeforeLoading = true;
      let copied = await stTimeEntryApi.copyDayPreviousWeek(this.selectedUserId, day.entryDay!);
      await this.loadData(DateTime.fromISO(day.entryDay!));
      if (!copied) {
        notifySuccess("Es wurden keine Zeiteinträge zum kopieren gefunden.");
      } else {
        if (copied == 1) {
          notifySuccess(`Es wurde ${copied} Zeiteintrag kopiert`);
        } else {
          notifySuccess(`Es wurden ${copied} Zeiteinträge kopiert`);
        }
      }
    } finally {
      this.copyWeekBeforeLoading = false;
    }
  }

  async userChanged(appUserId: number) {
    try {
      this.loading = true;
      this.selectedUserId = appUserId;
      await this.loadData(this.selectedDate);
    } finally {
      this.loading = false;
    }
  }

  async loadData(date: DateTime) {
    await TimeEntryStore.LoadTimeEntryDays(date);
  }
}
